import { createSelector } from 'reselect';

import { editorSelector } from 'modules/v2/editor/store/selectors/editor';

import { getBook, getBookId, getBookLayout } from './utils';

export const bookSelector = createSelector(editorSelector, getBook);
export const layoutSelector = createSelector(bookSelector, getBookLayout);
export const bookIdSelector = createSelector(bookSelector, getBookId);
